export const paymentPartnerOptions = [
  {
    text: 'Presentations',
    value: 'sales_material_partners_presentations'
  },
  { text: 'Handouts', value: 'sales_material_partners_handouts' },

  {
    text: 'Crypto Stats',
    value: 'sales_material_partners_crypto_stats'
  },
  {
    text: 'Internal Sales Material',
    value: 'sales_material_partners_internal_sales_material'
  }
];
export const customPartnerOptions = [
  {
    text: 'Presentations',
    value: 'sales_material_custom_merchant_presentations'
  },
  {
    text: 'Handouts',
    value: 'sales_material_custom_partner_presentations'
  },
  {
    text: 'Sales Videos',
    value: 'sales_material_custom_sales_videos'
  }
];
export const merchantSalesMaterialOptions = [
  {
    text: 'Presentations',
    value: 'sales_material_merchants_presentations'
  },
  { text: 'Handouts', value: 'sales_material_merchants_handouts' },
  { text: 'E-Books', value: 'sales_material_merchants_ebooks' }
];

export const salesMaterialVideosOptions = [
  {
    text: 'Sales Videos',
    value: 'sales_videos'
  },
  {
    text: 'Demo Videos',
    value: 'demo_videos'
  }
];
